import { TopNav } from "../../../components/Navbar/Webpages/TopNav";
import { Link } from "react-router-dom";
import { FaChartPie } from "react-icons/fa";
import { BsFillBarChartFill } from "react-icons/bs";
import { AiOutlineAreaChart } from "react-icons/ai";
import { MdAreaChart } from "react-icons/md";
import {
  FaCheckCircle,
  FaArrowRight,
  FaUserPlus,
  FaWallet,
  FaMoneyBillWave,
  FaHandHoldingUsd,
} from "react-icons/fa";
import { TickerTape, MarketOverview } from "react-tradingview-embed";
import aboutUs from "../../../asset/aboutus.jpeg";
import Footer from "../../../components/Layout/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade, Pagination } from "swiper";
import { MdSecurity, MdSpeed } from "react-icons/md";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { TeamCard } from "../../../components/Cards/WebpagesCards";
import { PlanSection } from "../../../components/Sections/PlanSection";
import { Testimonail } from "../../../components/Layout/Testimonail";
import { JourneySummaryModern } from "../../../components/Layout/Summary";
import { PartnersSection } from "../../../components/Layout/PartnerSection";

const Home = () => {
  const sliderContent = [
    {
      heading: "Zam-chain Advanced Investment platform",
      content:
        "Zam-chain Advanced investment.com is a trusted and innovative investment platform focused on delivering smart and secure financial growth. We specialize in modern trading and digital investment solutions designed to help you grow your capital efficiently. ",
      id: 1,
      img: "/img/home/showcase/showcase.png",
    },
    {
      heading: "Secure investments, seamless transactions",
      id: 2,
      img: "/img/home/showcase/showcase.png",
    },
  ];

  const featureCards = [
    {
      id: 1,
      icon: FaChartPie,
      title: "Profitable Plans",
      description:
        "We provide our members with access to carefully selected commercial investment opportunities that are usually out of reach for the average investor. Through Zam-Chain Advanced Investment, participants can explore a wide range of income-generating assets, including retail spaces, residential developments, and office properties.",
    },
    {
      id: 2,
      icon: BsFillBarChartFill,
      title: "Support Service",
      description:
        "At Zam-Chain Advanced Investment, we are committed to providing reliable and responsive support to all our members. Our dedicated team is always available to guide you through every stage of your investment journey, ensuring clarity, confidence, and ease.",
    },
    {
      id: 3,
      icon: AiOutlineAreaChart,
      title: "Fast Withdrawal",
      description:
        "At Zam-Chain Advanced Investment, we ensure a smooth and efficient withdrawal process for all our members. Our system is designed to deliver quick access to your earnings without unnecessary delays or complications.",
    },
    {
      id: 4,
      icon: MdAreaChart,
      title: "Advanced Security",
      description:
        "At Zam-Chain Advanced Investment, your security is our top priority. We use advanced systems and modern technology to protect your personal information and investments at every stage.",
    },
    {
      id: 3,
      icon: AiOutlineAreaChart,
      title: "Fast Withdrawal",
      description:
        "At Zam-Chain Advanced Investment, we ensure a smooth and efficient withdrawal process for all our members. Our system is designed to deliver quick access to your earnings without unnecessary delays or complications.",
    },
    {
      id: 3,
      icon: AiOutlineAreaChart,
      title: "Fast Withdrawal",
      description:
        "At Zam-Chain Advanced Investment, we ensure a smooth and efficient withdrawal process for all our members. Our system is designed to deliver quick access to your earnings without unnecessary delays or complications.",
    },
  ];
  return (
    <div>
      <TopNav />

      <div className="relative h-screen  w-full bg-gray-900">
        <Swiper
          modules={[Navigation, Autoplay, EffectFade, Pagination]}
          effect={"fade"}
          speed={1000}
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          className="h-full w-full"
        >
          {sliderContent.map(({ heading, id, content, img }) => (
            <SwiperSlide key={id} className="relative h-full w-full">
              {/* 1. Background Image */}
              <div className="absolute inset-0 z-0">
                <img
                  // Use the slide specific image, or fallback to your default
                  src={img || "/img/home/showcase/showcase.png"}
                  alt="Background"
                  className="w-full h-full object-cover transform scale-105 animate-slow-zoom" // Added subtle zoom animation class
                />
              </div>

              {/* 2. Overlays for Depth & Brand Color */}
              {/* Layer A: Deep Brand Tint */}
              <div className="absolute inset-0 bg-primary/80 mix-blend-multiply z-10"></div>
              {/* Layer B: Gradient for Text Readability (Left to Right) */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent z-10"></div>

              {/* 3. Content Container */}
              <div className="relative z-20 container max-w-screen-xl mx-auto h-full px-4 flex items-center">
                <div className="grid lg:grid-cols-2 gap-12 items-center w-full pt-20">
                  {/* Left Column: Text */}
                  <div className="max-w-2xl">
                    {/* Badge */}
                    <div
                      className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-4"
                      data-aos="fade-down"
                    >
                      <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                      <span className="text-white text-xs font-heading font-bold tracking-widest uppercase">
                        #1 Investment Platform
                      </span>
                    </div>

                    {/* Heading */}
                    <h1
                      className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] mb-6 tracking-tight drop-shadow-lg"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      {heading}
                    </h1>

                    {/* Description */}
                    <h6
                      className="font-body text-lg  text-gray-200 leading-relaxed mb-8 max-w-lg opacity-90"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      {content}
                    </h6>

                    {/* Modern Feature Grid (Checklist) */}
                    <div
                      className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    >
                      {[
                        "Instant Withdrawals",
                        "Advanced Security System",
                        "Global Access & Registration",
                        "Fully Protected Investment Process",
                      ].map((feature, idx) => (
                        <div
                          key={idx}
                          className="flex items-center gap-3 p-3 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors"
                        >
                          <div className="shrink-0 bg-primary/20 p-1 rounded-full text-primary-light">
                            <FaCheckCircle className="text-sm text-blue-300" />
                          </div>
                          <span className="font-body text-white text-sm font-medium">
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>

                    {/* Buttons */}
                    <div
                      className="flex flex-col sm:flex-row gap-4"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      <Link to="/register">
                        <button className="w-full sm:w-auto px-8 py-4 bg-primary text-white font-heading font-bold rounded-full shadow-lg shadow-primary/40 hover:bg-white hover:text-primary transition-all duration-300 flex items-center justify-center gap-2 group">
                          Get Started
                          <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                        </button>
                      </Link>
                      <Link to="/about">
                        <button className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white/30 text-white font-heading font-bold rounded-full hover:bg-white/10 transition-all duration-300">
                          Learn More
                        </button>
                      </Link>
                    </div>
                  </div>

                  {/* Right Column: Floating Stats (Optional - adds depth) */}
                  {/* Hidden on mobile, shown on large screens */}
                  <div className="hidden lg:block relative h-full">
                    <div className="absolute right-0 top-1/2 -translate-y-1/2">
                      {/* Glass Card 1 */}
                      <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-3xl mb-6 w-72 transform translate-x-8 animate-float-slow">
                        <div className="flex items-center gap-4 mb-3">
                          <div className="p-3 bg-blue-500/20 rounded-full text-blue-200">
                            <MdSpeed className="text-2xl" />
                          </div>
                          <div>
                            <p className="text-xs text-gray-300 uppercase font-bold">
                              Processing
                            </p>
                            <p className="text-white font-bold text-lg">
                              Instant
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Glass Card 2 */}
                      <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-3xl w-72 transform -translate-x-4 animate-float-delayed">
                        <div className="flex items-center gap-4 mb-3">
                          <div className="p-3 bg-green-500/20 rounded-full text-green-200">
                            <MdSecurity className="text-2xl" />
                          </div>
                          <div>
                            <p className="text-xs text-gray-300 uppercase font-bold">
                              Protection
                            </p>
                            <p className="text-white font-bold text-lg">
                              Bank Grade
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* CSS for custom animations if not in global css */}
        <style jsx>{`
          @keyframes float-slow {
            0%,
            100% {
              transform: translateY(0px) translateX(2rem);
            }
            50% {
              transform: translateY(-20px) translateX(2rem);
            }
          }
          @keyframes float-delayed {
            0%,
            100% {
              transform: translateY(0px) translateX(-1rem);
            }
            50% {
              transform: translateY(-15px) translateX(-1rem);
            }
          }
          .animate-float-slow {
            animation: float-slow 6s ease-in-out infinite;
          }
          .animate-float-delayed {
            animation: float-delayed 7s ease-in-out infinite;
          }
          .animate-slow-zoom {
            animation: zoom 20s infinite alternate;
          }
          @keyframes zoom {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(1.1);
            }
          }
        `}</style>
      </div>
      <div className="h-10 w-full my-92 bg-white ">
        <TickerTape
          widgetProps={{
            theme: "light",
            symbols: [
              { proName: "CRYPTOCAP:BTC", title: "Bitcoin" },
              { proName: "CRYPTOCAP:ETH", title: "Ethereum" },
              { proName: "CRYPTOCAP:BNB", title: "BNB" },
              { proName: "CRYPTOCAP:ADA", title: "Cardano" },
              { proName: "CRYPTOCAP:SOL", title: "Solana" },
              { proName: "CRYPTOCAP:XRP", title: "XRP" },
            ],
            showSymbolLogo: true,
            colorTheme: "light",
            isTransparent: false,
            displayMode: "regular",
            locale: "en",
          }}
        />
      </div>

      <div className="container max-w-screen-md mx-auto px-4 py-12 mt-10">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="w-8 h-0.5 bg-primary mr-3"></div>
            <span className="text-2xl text-primary font-medium">Why</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-gray-800">
            Zam-chain Advanced Investment Platform
          </h2>
          <p className="font-body text-sm text-textGray mt-4">
            At Zam-Chain Advanced Investment, we provide our members with access
            to premium commercial investment opportunities that are typically
            reserved for elite investors and large financial institutions. Our
            platform opens the door to carefully selected projects across
            retail, multi-family housing, and office properties.
          </p>
          <p className="font-body text-sm text-textGray mt-4">
            We are committed to delivering transparency, structured investment
            processes, and consistent value, ensuring that every member can
            confidently participate and grow their portfolio through secure and
            well-managed opportuniti
          </p>
        </div>
      </div>

      <div className="">
        <div className="container max-w-screen-lg mx-auto px-4 py-12">
          <div className="grid grid-cols-1 gap-x-6 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
            {featureCards.map(
              ({ id, icon: Icon, title, description }, index) => (
                <div
                  key={id}
                  className="group text-center bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl hover:shadow-blue-900/5 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="bg-lightprimary rounded-full p-1 h-10 w-10 -mt-10 flex items-center justify-center mx-auto">
                    <Icon
                      className="text-xl  text-primary"
                      // data-aos={"fade-up"}
                    />
                  </div>

                  <h5 className="font-heading text-lg my-4 font-medium capitalize">
                    {title}
                  </h5>
                  <p className="font-body text-textGray text-sm leading-relaxed">
                    {description}
                  </p>
                </div>
              ),
            )}
          </div>
        </div>
      </div>

      <div className="bg-white overflow-hidden">
        <div className="container max-w-screen-xl mx-auto px-4 py-24">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Column: Text Content */}
            <div className="self-center">
              {/* Tagline */}
              <div className="flex items-center mb-4">
                <div className="w-8 h-0.5 bg-primary mr-3"></div>
                <h1 className="font-heading font-bold text-sm uppercase tracking-widest text-primary">
                  About Us
                </h1>
              </div>

              {/* Main Headline */}
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                An Amazing Place <br />
                <span className="text-primary">
                  An Amazing Place To Grow Your Wealth
                </span>
              </h2>

              <p className="font-body text-gray-600 leading-relaxed text-justify mb-8">
                Zam-Chain Advanced Investment is a modern investment platform
                built and managed by a team of experienced financial
                professionals and skilled market analysts. Our focus is to
                provide reliable and profitable investment opportunities for
                individuals and organizations seeking to grow their wealth
                through structured and innovative systems.
              </p>
              <p className="font-body text-gray-600 leading-relaxed text-justify mb-8">
                We take pride in serving a diverse range of investors, including
                individuals, business owners, and corporate clients, all united
                by a common goal of achieving steady financial growth in a
                secure environment.
              </p>

              <div className="space-y-8">
                {/* Mission Section */}
                <div className="relative pl-4 border-l-2 border-blue-100 hover:border-primary transition-colors duration-300">
                  <div className="flex items-center mb-2">
                    <h3 className="font-heading font-bold text-lg text-gray-900">
                      Our Mission
                    </h3>
                  </div>
                  <p className="font-body text-sm text-gray-500 leading-relaxed text-justify">
                    Our mission is to provide a secure, transparent, and
                    efficient investment platform that empowers users to achieve
                    consistent returns. Through advanced technology and smart
                    investment strategies, we aim to deliver stable and
                    sustainable growth for every member.
                  </p>
                </div>

                {/* Vision Section */}
                <div className="relative pl-4 border-l-2 border-blue-100 hover:border-primary transition-colors duration-300">
                  <div className="flex items-center mb-2">
                    <h3 className="font-heading font-bold text-lg text-gray-900">
                      Our Vision
                    </h3>
                  </div>
                  <p className="font-body text-sm text-gray-500 leading-relaxed text-justify">
                    Our vision is to make high-quality investment opportunities
                    accessible to everyone, creating a future where financial
                    growth and independence are within reach for all. We strive
                    to build trust through transparency, innovation, and
                    long-term value creation.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="relative" data-aos="fade-right">
              {/* Decorative background box */}
              <div className="absolute -inset-4 bg-blue-50 rounded-3xl transform rotate-2 z-0"></div>

              <img
                src={aboutUs}
                alt="About Zam-chain Advanced investment"
                className="relative w-full rounded-2xl shadow-xl z-10 transform transition duration-500 hover:scale-[1.01]"
              />

              {/* Optional Floating Badge */}
              <div className="absolute bottom-6 left-6 z-20 bg-white/90 backdrop-blur-md px-6 py-4 rounded-xl shadow-lg border border-white/50 hidden md:block">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider">
                  Experience
                </p>
                <p className="text-xl font-bold text-primary">10+ Years</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Process Section */}
      <div className="py-16 bg-gray-50">
        <div className="container max-w-screen-xl mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <div className="w-8 h-0.5 bg-primary mr-3"></div>
              <span className="text-2xl text-primary font-medium">Process</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-gray-800 mb-4">
              Our Process is Simple and Short
            </h2>
            <p className="text-textGray font-body max-w-3xl mx-auto leading-relaxed">
              Distinctively grow to go forward manufactured products and optimal
              networks. Enthusiastically disseminate outsourcing through
              revolutionary.
            </p>
          </div>

          {/* Process Steps */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6 relative">
                <FaUserPlus className="text-white text-2xl" />
                <span className="absolute -top-2 -right-2 bg-white text-primary rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                  1
                </span>
              </div>
              <h3 className="font-heading font-semibold text-xl mb-3">
                Sign Up
              </h3>
              <p className="text-textGray font-body text-sm leading-relaxed">
                Click on the registration button to get a new account
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6 relative">
                <FaWallet className="text-white text-2xl" />
                <span className="absolute -top-2 -right-2 bg-white text-primary rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                  2
                </span>
              </div>
              <h3 className="font-heading font-semibold text-xl mb-3">
                Set Up Your Wallet
              </h3>
              <p className="text-textGray font-body text-sm leading-relaxed">
                Login to your account to add new wallet
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6 relative">
                <FaMoneyBillWave className="text-white text-2xl" />
                <span className="absolute -top-2 -right-2 bg-white text-primary rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                  3
                </span>
              </div>
              <h3 className="font-heading font-semibold text-xl mb-3">
                Make A Deposit
              </h3>
              <p className="text-textGray font-body text-sm leading-relaxed">
                Make a deposit from any of our plans convenient for you.
              </p>
            </div>

            {/* Step 4 */}
            <div className="text-center">
              <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6 relative">
                <FaHandHoldingUsd className="text-white text-2xl" />
                <span className="absolute -top-2 -right-2 bg-white text-primary rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                  4
                </span>
              </div>
              <h3 className="font-heading font-semibold text-xl mb-3">
                Make Withdrawal
              </h3>
              <p className="text-textGray font-body text-sm leading-relaxed">
                Withdraw your earnings anytime or reinvest to earn more.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="">
        <div className="container max-w-screen-xl mx-auto px-4 py-16 ">
          <h1 className="text-xl md:text-3xl text-center font-heading font-semibold">
            Investment Plans
          </h1>
          <p className="text-center  max-w-screen-md mx-auto my-6 font-body text-sm text-textGray">
            Zam-chain Advanced Investment. has multiple investment plans to
            choose from. Both plans are structured with simplicity in mind so
            that even the newest of investors can interpret and leverage either
            plan to cultivate respectable profits.
          </p>
          <PlanSection />
        </div>
      </div>

      <div className="">
        <div className="container max-w-screen-xl mx-auto px-4 p-16 ">
          <div className="flex flex-col items-center">
            <div className="flex items-center justify-center mb-4">
              <div className="w-8 h-0.5 bg-primary mr-3"></div>
              <span className="text-2xl text-primary font-medium">
                The Team
              </span>
            </div>
            <h1 className="text-xl md:text-4xl text-center font-heading font-semibold">
              Industry Experts
            </h1>
            <p className="font-body text-sm  my-4 text-center text-textGray max-w-screen-md">
              Our professionals team are educated and talented traders. Our
              experts give you benefit from total transparency to achieve
              control and make better decisions.
            </p>
          </div>

          <div
            className="overflow-scroll md:overflow-auto"
            data-aos={"fade-up"}
          >
            <div className="grid grid-cols-4 w-960px lg:w-1124px xl:w-1240px mx-auto gap-4 mt-8">
              <TeamCard />
            </div>
          </div>

          {/* <HomeTable /> */}

          {/* Crypto Market Overview */}
          <div className="mt-12">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center mb-4">
                <div className="w-8 h-0.5 bg-primary mr-3"></div>
                <span className="text-2xl text-primary font-medium">
                  Market
                </span>
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-semibold text-gray-800">
                Cryptocurrency Market Overview
              </h2>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-4 overflow-hidden">
              <MarketOverview
                widgetProps={{
                  colorTheme: "light",
                  dateRange: "12M",
                  showChart: true,
                  locale: "en",
                  largeChartUrl: "",
                  isTransparent: false,
                  showSymbolLogo: true,
                  showFloatingTooltip: false,
                  width: "100%",
                  height: "400",
                  plotLineColorGrowing: "rgba(41, 98, 255, 1)",
                  plotLineColorFalling: "rgba(41, 98, 255, 1)",
                  gridLineColor: "rgba(240, 243, 250, 0)",
                  scaleFontColor: "rgba(106, 109, 120, 1)",
                  belowLineFillColorGrowing: "rgba(41, 98, 255, 0.12)",
                  belowLineFillColorFalling: "rgba(41, 98, 255, 0.12)",
                  belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
                  belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
                  symbolActiveColor: "rgba(41, 98, 255, 0.12)",
                  tabs: [
                    {
                      title: "Crypto",
                      symbols: [
                        { s: "CRYPTOCAP:BTC", d: "Bitcoin" },
                        { s: "CRYPTOCAP:ETH", d: "Ethereum" },
                        { s: "CRYPTOCAP:BNB", d: "BNB" },
                        { s: "CRYPTOCAP:XRP", d: "XRP" },
                        { s: "CRYPTOCAP:ADA", d: "Cardano" },
                        { s: "CRYPTOCAP:SOL", d: "Solana" },
                        { s: "CRYPTOCAP:DOGE", d: "Dogecoin" },
                        { s: "CRYPTOCAP:DOT", d: "Polkadot" },
                        { s: "CRYPTOCAP:AVAX", d: "Avalanche" },
                        { s: "CRYPTOCAP:MATIC", d: "Polygon" },
                      ],
                      originalTitle: "Crypto",
                    },
                  ],
                }}
              />
            </div>
          </div>

          <JourneySummaryModern />
        </div>
      </div>
      <Testimonail />

      {/* Moving Companies Logo Section */}
      <PartnersSection />
      <Footer />
    </div>
  );
};

export default Home;
